<template>
    <div :class="['wrapper', {'no-events': noEvents}]">
      <div :class="['overlay', {'active': overlay}]"></div>
      <div :class="['layer-row top-half', {'colored': intro, 'opened': open}]">
        <v-fade-transition>
          <v-img
              v-show="showAssets"
              class="mx-auto logo"
              :src="require(isDark ? '@/assets/img/logo/rectangle.png' : '@/assets/img/logo/rectangle_light.png')"
              width="100%" contain max-width="200" />
        </v-fade-transition>
      </div>

      <v-progress-linear v-if="showAssets" class="spinner" indeterminate size="200" height="1" color="primary"></v-progress-linear>

      <div :class="['layer-row bottom-half', {'colored': intro, 'opened': open}]">

      </div>


    </div>
</template>
<script>
    import DevByKimsa from "@/components/common/DevByKimsa";
    export default{
      components: {DevByKimsa},
      props: {
          loading: {
            type: Boolean,
            default: true
          }
        },
      data(){
        return {
          intro: false,
          overlay: false,
          showAssets: true,
          open: false,
          noEvents: false
        }
      },
      mounted() {
        const vm = this
        vm.intro = true
        vm.overlay = true
        let audio = document.getElementById('intro_sound')
        audio.volume = 0.05;
        setTimeout(function(){
          audio.play()
        }, 500)
      },
      watch:{
          loading(val){
            const vm = this
            if(!val){
              vm.overlay = false
              vm.showAssets = false
              setTimeout(function(){
                vm.open = true
                vm.noEvents = true
              }, 500)
            }
          }
      }
    }
</script>
<style scoped>

    :root {
        --layer-scale: .7;
    }

    .overlay{
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 10;
      background: rgba(87,80,234, 0);
      background: radial-gradient(circle, rgba(0,0,0,0) 0%, var(--v-background-darken2) 90%);
      opacity: 0;
      transition: opacity .5s ease-in-out;
    }

    .overlay.active{
      opacity: 1;
    }

    .spinner{
      position: fixed;
      top: 50%;
      left: 0;
      width: 100%;
      margin: 0;
      z-index: 1;
    }

    .wrapper{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        z-index: 1000;
        background-color: transparent;
    }

    .wrapper.no-events{
      pointer-events: none;
    }

    .layer-row{
      position: absolute;
      left: 0;
      height: 50%;
      width: 100%;
      background-color: #FFFFFF;
      transition: background-color, transform .5s ease-in-out;
    }

    .layer-row.colored{
      animation: intro .8s forwards;
    }

    .logo{
      bottom: 15px;
      width: 200px;
      position: absolute;
      left: calc(50% - 100px);
      z-index: 10;
    }

    .powered-by{
      top: 10px;
      width: 100%;
      position: absolute;
      text-align: center;
      left: 0;
      z-index: 10;
    }

    .top-half{
      top: 0;
    }

    .bottom-half{
      bottom: 0;
    }

    .top-half,
    .bottom-half{
      transform: translateY(0);
      transition: transform 2s ease-out;
    }

    .top-half.opened{
      transform: translateY(-4000px);
    }

    .bottom-half.opened{
      transform: translateY(4000px);
    }

    @keyframes intro {

        0%{
            background-color: var(--v-background-darken2);
        }

        100%{
            background-color: var(--v-background-lighten1);
        }

    }


</style>
